export default "__VITE_ASSET__D1FsMvqT__"